import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const GetStartedContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${Spacing.S40};
  justify-content: space-between;
  width: 100%;
  height: 100%;
`
